import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {
  currentUser: null,
  token: null,
  isAuthenticated: false,
  loading: false,
  error: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.currentUser = action.payload.user;
      state.token = action.payload.token;
      state.isAuthenticated = true;
      state.loading = false;
      state.error = null;
      
      // Set the Authorization header
      axios.defaults.headers.common['Authorization'] = `Bearer ${action.payload.token}`;
    },
    logout: (state) => {
      state.currentUser = null;
      state.token = null;
      state.isAuthenticated = false;
      state.loading = false;
      state.error = null;
      // Clear token from localStorage
      localStorage.removeItem('token');
      // Remove Authorization header
      delete axios.defaults.headers.common['Authorization'];
    },
    updateUserInfo: (state, action) => {
      state.currentUser = { ...state.currentUser, ...action.payload };
    },
    loginFailure: (state, action) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
    addAddress: (state, action) => {
      if (!state.currentUser.addresses) {
        state.currentUser.addresses = [];
      }
      state.currentUser.addresses.push(action.payload);
    },
    updateAddress: (state, action) => {
      const index = state.currentUser.addresses.findIndex(
        (addr) => addr._id === action.payload._id
      );
      if (index !== -1) {
        state.currentUser.addresses[index] = action.payload;
      }
    },
    removeAddress: (state, action) => {
      state.currentUser.addresses = state.currentUser.addresses.filter(
        (addr) => addr._id !== action.payload
      );
    },
    addOrder: (state, action) => {
      if (!state.currentUser.orders) {
        state.currentUser.orders = [];
      }
      state.currentUser.orders.unshift(action.payload);
    }
  },
});

export const {
  loginSuccess,
  logout,
  loginFailure,
  clearError,
  updateUserInfo,
  addAddress,
  updateAddress,
  removeAddress,
  addOrder
} = userSlice.actions;

export default userSlice.reducer;